import Preact from 'preact';
import Box from '@mui/system/Box';
import * as Navigation from '../store/actions/navigation';
import { ConfigureButtonLocation } from '../store/actions/navigation';
import { useTheme } from '@mui/material/styles';
import { Zoom } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ContextMenu, icons } from '@dora/components';

export const Component = (props: {
    bottomPadding: number;
    size: 'small' | 'medium' | 'large';
    show: boolean;
    showConfigure: boolean;
    onDelete: (from: Navigation.ConfigureButtonLocation) => void;
    onConfigure: () => void;
}) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const buttons: ContextMenu.Buttons = {};
    if (props.showConfigure) {
        buttons.configure = {
            Icon: icons.ConfigIcon,
            onSelect: () => {
                dispatch(
                    Navigation.modularSofaConfigureExistingAction({
                        from: ConfigureButtonLocation.CONTEXT_MENU,
                    }),
                );
                props.onConfigure();
            },
            'aria-label': 'configure selected furniture',
        };
    }

    buttons.delete = {
        Icon: icons.DeleteIcon,
        onSelect: () => {
            props.onDelete(ConfigureButtonLocation.CONTEXT_MENU);
        },
        'aria-label': 'delete selected furniture',
    };

    return (
        <Box
            position="absolute"
            zIndex={theme.zIndex.drawer}
            bottom={props.bottomPadding}
            left="50%"
            sx={{ transform: 'translate(-50%, 0)' }}
        >
            <Zoom key={props.showConfigure} in={props.show} unmountOnExit>
                <Box display="flex" gap="16px">
                    <ContextMenu.Component
                        buttons={buttons}
                        size={props.size}
                        aria-label="furniture context menu"
                    />
                </Box>
            </Zoom>
        </Box>
    );
};
